import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ValidationService } from '@core/services/api/http/validation.service';
import { Masks, Patterns } from '@global/enums';
import { ModalController } from '@ionic/angular';
import { MaskitoOptions } from '@maskito/core';
import dayjs from 'dayjs';
import { Observable, throwError } from 'rxjs';
import { catchError, distinctUntilChanged, first } from 'rxjs/operators';

@Component({
  selector: 'qb-de-promotional-code-modal',
  templateUrl: './promotional-code-modal.component.html',
  styleUrls: ['./promotional-code-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class QbPromotionalCodeModalComponent implements OnInit {
  @Input() promoCode?: string;

  protected readonly validationService: ValidationService = inject(ValidationService);

  promoCodeError?: string;
  promoCodeMask: MaskitoOptions = Masks.PROMO_CODE;

  promoCodeForm: FormGroup<{
    promoCode: FormControl<string>;
  }> = new FormGroup({
    promoCode: new FormControl<string>(undefined, {
      validators: [Validators.required],
      nonNullable: true,
    }),
  });

  closeIconAriaLabel = 'ACCESSIBILITY.MODAL.CLOSE';
  translateService: any;

  serviceLoading?: Observable<boolean>;

  constructor(
    private readonly modalCtrl: ModalController,
    private readonly cdr: ChangeDetectorRef
  ) {
    this.promoCodeForm.controls.promoCode.valueChanges.pipe(distinctUntilChanged()).subscribe(() => {
      this.promoCodeError = undefined;
    });

    this.serviceLoading = this.validationService.postPromotionCodeLoading$;
  }

  ngOnInit(): void {
    this.promoCodeForm.controls.promoCode.setValue(this.promoCode);
  }

  onButtonClicked(): void {
    this.validationService
      .postPromotionCode({
        cooperationId: '00',
        ratingDate: dayjs(new Date()).format(Patterns.DATE_DASH_YYYYMMDD),
        promotionCode: this.promoCodeForm.controls.promoCode.value,
      })
      .pipe(
        first(),
        catchError((response: HttpErrorResponse) => {
          switch (response.status) {
            case HttpStatusCode.BadRequest:
            default:
              this.promoCodeError = response.error.userMsg ?? this.translateService.instant('GENERIC_ERROR.TITLE');
              this.cdr.detectChanges();
          }
          return throwError(() => new Error(response.message));
        })
      )
      .subscribe(() => {
        this.modalCtrl.dismiss(this.promoCodeForm.controls.promoCode.value);
      });
  }

  dismiss(): void {
    this.modalCtrl.dismiss();
  }
}
